const env = {
  VITE_ENVIRONMENT_NAME: (import.meta.env.VITE_ENVIRONMENT_NAME ||
    'development') as 'beta' | 'qa' | 'development',
  VITE_STRIPE_PUBLISHABLE_KEY:
    import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '',
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN || '',
  VITE_AMPLITUDE_API_KEY: import.meta.env.VITE_AMPLITUDE_API_KEY || '',
  VITE_AMPLITUDE_ENVIRONMENT_NAME:
    import.meta.env.VITE_AMPLITUDE_ENVIRONMENT_NAME || '',
  VITE_INSTILL_API_BASE_URL: import.meta.env.VITE_INSTILL_API_BASE_URL || '',
  VITE_MICROSOFT_OUTLOOK_CLIENT_ID:
    import.meta.env.VITE_MICROSOFT_OUTLOOK_CLIENT_ID || '',
  VITE_CLIENT_BASE_URL: import.meta.env.VITE_CLIENT_BASE_URL || '',
  VITE_GOOGLE_CALENDAR_CLIENT_ID:
    import.meta.env.VITE_GOOGLE_CALENDAR_CLIENT_ID || '',
  VITE_ZOOM_CLIENT_ID: import.meta.env.VITE_ZOOM_CLIENT_ID || '',
  VITE_AUTH0_DOMAIN: import.meta.env.VITE_AUTH0_DOMAIN || '',
  VITE_AUTH0_CLIENT_ID: import.meta.env.VITE_AUTH0_CLIENT_ID || '',
  VITE_AUTH0_AUDIENCE: import.meta.env.VITE_AUTH0_AUDIENCE || '',
  VITE_GOOGLE_CALENDAR_EVENTS_READONLY_SCOPE:
    import.meta.env.VITE_GOOGLE_CALENDAR_EVENTS_READONLY_SCOPE || '',
  VITE_WEB_SOCKET_DOMAIN: import.meta.env.VITE_WEB_SOCKET_DOMAIN || '',
  VITE_MAPBOX_TOKEN: import.meta.env.VITE_MAPBOX_TOKEN || '',
};

export default env;
